<template src="./review-dimensions-fieldset.html"></template>

<script lang="ts">
import { hostsConfig } from 'init/config'
import CheckGroup from 'objects/form/CheckGroup.vue'
import RangeField from 'objects/form/RangeField.vue'
import RatingMeter from 'components/rating/RatingMeterField.vue'
import reviewSubmissionConfig from 'widgets/submission/review-submission.config'
import Selectbox from 'objects/form/Selectbox.vue'

interface ValueDef {
  label: string
  value: string
  imagePath?: string
}

export default {
  data() {
    // local copy of the values. Will be updated with 'values' prop
    return { dimensionValues: {} }
  },
  props: {
    dimensionDefinitions: Array, // ReviewInitDataDimension
    dimensionErrors: Object, // property name is id of dim, value is error message string
    modelValue: {
      type: Object, // actual values
      required: true
    }
  },
  emits: ['update:modelValue'],
  components: {
    'tt-check-group': CheckGroup,
    'tt-range-field': RangeField,
    'tt-rating-meter': RatingMeter,
    'tt-selectbox': Selectbox
  },
  computed: {
    dimValDefs() {
      const valueDefs = {}
      if (this.dimensionDefinitions) {
        this.dimensionDefinitions.forEach((dimDef) => {
          if (dimDef.type === 1) { // rating
            valueDefs[dimDef.id] = dimDef.valueDefinitions
          } else {
            valueDefs[dimDef.id] = dimDef.valueDefinitions.map((valueDef) => {
              const def = { label: valueDef.label, value: `${valueDef.id}` } as ValueDef
              if (dimDef.type === 5) { // image select
                def.imagePath = this.getImagePath(valueDef.imageId)
              }
              return def
            })
          }
        })
      }
      return valueDefs
    },
    showDimensions() {
      const numOfDims = this.dimensionDefinitions ? this.dimensionDefinitions.length : 0
      const numOfValues = this.dimensionValues ? Object.keys(this.dimensionValues).length : 0
      return numOfDims > 0  && numOfValues === numOfDims
    },
    showRangeMiddle() {
      return reviewSubmissionConfig.showRangeMiddle
    }
  },
  methods: {
    checkGroupDimDisplayType(dimDef) {
      if (dimDef.displayAsTags) {
        return 'tag'
      } else if (dimDef.type === 5) {
        return 'image'
      }
      return dimDef.type === 3 || dimDef.type === 2 ? 'radio' : 'checkbox'
    },
    getImagePath(imageId) {
      return `${hostsConfig.protocol}://${hostsConfig.imageStoreBase}/custom-dim/${hostsConfig.siteKey}/${imageId}.png`
    },
    isCheckGroupDim(dimDef) {
      return (dimDef.type === 2 && this.dimValDefs[dimDef.id].length <= 2
        || dimDef.type === 3 && this.dimValDefs[dimDef.id].length <= 3)
        || dimDef.type === 4 || dimDef.type === 5
    },
    setupDimensionValues() {
      if (this.dimensionDefinitions) {
        this.dimensionDefinitions.forEach((dimDef) => {
          const stringId = dimDef.id
          let value = this.modelValue[stringId]
          if (value === undefined && this.dimensionValues[stringId] === undefined) {
            // default values so the fields works correctly
            value = dimDef.type === 4 ? [] : (dimDef.type === 1 ? 0 : '')
          }
          this.dimensionValues[stringId] = value
        })
      }
    }
  },
  watch: {
    // in Vue 3, arrays in watch must have deep: true
    dimensionDefinitions: {
      handler() {
        this.setupDimensionValues()
      },
      deep: true
    },
    // since the object doesn't change, but the values in the object might, set to deep: true
    dimensionValues: {
      handler() {
        this.$emit('update:modelValue', this.dimensionValues)
      },
      deep: true
    },
    modelValue() {
      this.setupDimensionValues()
    }
  },
  created() {
    this.setupDimensionValues()
  }
}
</script>

<style lang="scss" src="./review-dimensions-fieldset.scss"></style>
